import { get, post, delete as deleteRequest } from 'axios';
import { LUDUM_ERROR_CODES } from '@/constants';
require('formdata-polyfill');

onmessage = async function(event) {
    if (!event.data.payload) {
        return false;
    }
    const { method, url, data, config, params } = event.data.payload;
    if (!config) {
        return false;
    }
    let formData;
    let newData;
    // if we encounter any files, upload them as form data
    if ((data && data.toString() === '[object File]') || config.upload) {
        const file = data.file ? data.file : data;
        const paramName = config.paramName ? config.paramName : 'file';

        formData = new FormData();

        formData.append(paramName, file);

        Object.keys(data).forEach(field => {
            if (field !== 'file') {
                if (Array.isArray(data[field])) {
                    data[field].forEach(fieldItem => {
                        formData.append(`${field}[]`, fieldItem);
                    });
                } else {
                    formData.append(field, data[field]);
                }
            }
        });

        newData = formData;
    } else {
        newData = data;
    }

    if (params) {
        config.params = params;
    }

    try {
        let response;
        if (method === 'post') {
            response = await post(url, newData, config);
        } else if (method === 'get') {
            response = await get(url, config);
        } else if (method === 'delete') {
            response = await deleteRequest(url, config);
        }
        const serverResponse = response.data;
        if (
            (serverResponse.errors && serverResponse.errors.length) ||
            (serverResponse.status_code &&
                ![LUDUM_ERROR_CODES.OK, LUDUM_ERROR_CODES.PARTIAL_CONTENT].includes(serverResponse.status_code))
        ) {
            throw serverResponse;
        }
        const results = JSON.stringify({
            id: event.data.id,
            payload: response,
            error: null
        });
        postMessage(results);
    } catch (error) {
        if (error && error.response && error.response.status === LUDUM_ERROR_CODES.INTERNAL_SERVER_ERROR) {
            const errorObj = {
                id: event.data.id,
                payload: null,
                error: {
                    message: error.response.statusText,
                    status_code: error.response.statusCode,
                    internal: true
                }
            };
            return postMessage(JSON.stringify(errorObj));
        }
        return postMessage(JSON.stringify({ id: event.data.id, payload: null, error }));
    }
};
